<template>
  <div class="lab_test__pdf">
    <embed class="pdfContainer" type="application/pdf" :src="pdfLink" height="100%" width="100%" />
  </div>
</template>

<script>
import { baseURL } from '@/axios.js'

export default {
  name: 'ViewLabTestPdf',

  data() {
    return {
      pdfLink: `${baseURL}lab-test/${this.$route.params.id}/lab-test-pdf`
    }
  }
}
</script>

<style lang="scss">
.lab_test__pdf {
  height: 100vh;
}
</style>